import Form from './form';
export const FormController = 'FormController';

export default [Form];
